<template>
    <li
        class="com-menu-item"
        :class="{
            'com-menu-item--separator': separator,
            'com-menu-item--text': !separator
        }"
        @click="$emit('click')"
    >
        <slot></slot>
    </li>
</template>

<script>
export default {
    name: 'ComMenuItem',

    props: {
        separator: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.com-menu-item {
    &--separator {
        height: 1px;
        background: #333;
        margin-top: 6px;
        margin-bottom: 6px;
        cursor: default;
    }

    &--text {
        padding: 8px 15px;
        cursor: pointer;

        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
}
</style>
